import styled from 'styled-components'

export const H4 = styled.h4`
  border: 0;
  margin: 0;
  padding: 0
  font-size: 19px;
  font-weight: 600;
  line-height: 28px;

  color: ${props => props.theme.lightGray};
`